export default "__VITE_ASSET__bdca88fd__"